import { Progress as ProgressPrimitive } from "@base-ui/react/progress";

import { cn } from "@/shared/lib/utils";

function Progress({ className, ...props }: ProgressPrimitive.Root.Props) {
  return (
    <ProgressPrimitive.Root
      data-slot="progress"
      className={cn("flex flex-col gap-1.5", className)}
      {...props}
    />
  );
}

function ProgressTrack({ className, ...props }: ProgressPrimitive.Track.Props) {
  return (
    <ProgressPrimitive.Track
      data-slot="progress-track"
      className={cn("relative flex h-2 w-full overflow-hidden rounded-full bg-muted", className)}
      {...props}
    />
  );
}

function ProgressIndicator({ className, ...props }: ProgressPrimitive.Indicator.Props) {
  return (
    <ProgressPrimitive.Indicator
      data-slot="progress-indicator"
      className={cn(
        "h-full rounded-full bg-primary transition-[width] duration-300 ease-out motion-reduce:transition-none data-indeterminate:w-1/3 data-indeterminate:animate-pulse motion-reduce:data-indeterminate:animate-none",
        className,
      )}
      {...props}
    />
  );
}

export { Progress, ProgressIndicator, ProgressTrack };
